import App from './AppAvailabilityWidget.svelte';
import Button from './CheckAvailabilityButton.svelte';

const target = document.getElementById('availability');
const targetButtonSkeleton = document.getElementById('availability-toggle-skeleton');
const { contextItemId } = target.dataset;
const antiForgeryToken = target.querySelector(
  '[name="__RequestVerificationToken"]'
).value;

const app = new App({
  target,
  props: {
    sitecoreContextItemId:
      typeof contextItemId === 'undefined' ? {} : contextItemId,
    sitecoreFormToken:
      typeof antiForgeryToken === 'undefined' ? {} : antiForgeryToken,
    elementShadow: targetButtonSkeleton,
  },
});

const sidebarButtonSkeleton = document.getElementById('availability-sidebar-toggle-skeleton')

const checkAvailabilitySideBarButton = new Button({
  target: document.getElementById('checkAvailabilitySideBar'),
  props: {
    elementId: 'availability-mobile',
    elementShadow: sidebarButtonSkeleton,
  },
});

const mobileButtonSkeleton = document.getElementById('availability-mobile-toggle-skeleton')
const checkAvailabilityMobileButton = new Button({
  target: document.getElementById('checkAvailabilityMobile'),
  props: {
    elementId: 'availability-sidebar',
    elementShadow: mobileButtonSkeleton,
  },
});

export default {
  app,
  checkAvailabilitySideBarButton,
  checkAvailabilityMobileButton,
};
